import {ChatVersions} from "shared/chat.versions";

interface Environment {
    paidRooms: boolean,
    production: boolean,
    version: string,
    gaId: string,
    chatVersion: ChatVersions,
    language: string,
    translations: object,
    name: string,
    canonicalDomain: string,
    prerenderDomain: string,
    enDomain: string,
    ruDomain: string,
    baseDomain: string,
    websocket: string,
    api: string,
}

export function prepareEnvironment(language: string, translations: object, domain: string, chatVersion: ChatVersions, gaId: string, prerenderDomain?: string): Environment {

    let host: string
    let name: string

    if (typeof window !== 'undefined') {
        host = window.location.hostname
    } else {
        host = domain
    }

    if (chatVersion === ChatVersions.SX) {
        name = '18SexChat'
    } else {
        name = 'Virt-chat'
    }

    const baseDomain = getBaseDomain(host)

    // Доменная сеть: EN-версия (18sexchat) и RU-версия (virt-chat).
    // Используется для построения взаимного hreflang (кластеризация доменов для Google).
    const enDomain = '18sexchat.net'
    const ruDomain = 'virt-chat.net'

    return {
        paidRooms: true,
        production: true,
        version: '1.30.1',
        gaId: gaId,
        chatVersion: chatVersion,
        language: language,
        translations: translations,
        name: name,
        canonicalDomain: domain,
        prerenderDomain: prerenderDomain || domain,
        enDomain: enDomain,
        ruDomain: ruDomain,
        baseDomain: baseDomain,
        websocket: `wss://server.${baseDomain}`,
        api: `https://api.${baseDomain}`,
    }
}

export function getBaseDomain(hostname: string): string {
    const parts = hostname.split('.');

    // Если меньше 2 частей, возвращаем как есть
    if (parts.length < 2) {
        return hostname;
    }

    // Берем последние 2 части (example.com)
    return parts.slice(-2).join('.');
}